import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects ✍️`}</h2>
    <ProjectCard title='KienLong Webform C#' link='https://github.com/baobaoack000/KienLong-Submit-Form-C-.CORE-' bg='linear-gradient(to right, #eedb4b 0%, #FBB03B 100%)' mdxType="ProjectCard">
  📕 This project i made with visual code 2019 to create a webform with Asp.Net
  Core / Sql server 2019.
    </ProjectCard>
    <ProjectCard title='Express.JS Generator' link='https://github.com/baobaoack000/Mobirises-Heroku-' bg='linear-gradient(to right, #b4ee4b 0%, #FBB03B 100%)' mdxType="ProjectCard">
  📕 This project using pre-built website that generate using Express-cli and
  deploy with Heroku .
    </ProjectCard>
    <ProjectCard title='Webscrapping Python' link='https://github.com/baobaoack000/Group-Webscraping-Finish-' bg='linear-gradient(to right, #D4145A 0%, #FBB03B 100%)' mdxType="ProjectCard">
  📕 This project create to generate datas using http and excel with
  Beautiful-Soup & Jupyter notebook.
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      